<template>
	<el-dialog :title="title + ' · 示例预览'" :visible.sync="visible" width="88%" append-to-body>
		<el-alert title="以下为示例数据；实际首页按登录用户的业务权限和门店范围展示。" type="info" :closable="false" />
		<el-radio-group v-model="device" size="small" class="device-switch"><el-radio-button label="desktop">桌面端</el-radio-button><el-radio-button label="mobile">窄屏预览</el-radio-button></el-radio-group>
		<div class="preview-grid" :class="{mobile:device==='mobile'}">
			<home-widget
				v-for="(item, index) in sorted"
				:key="index"
				:style="{ gridColumn: item.placement.col + '/span ' + item.placement.width, gridRow: item.placement.row }"
				:placement="item.placement"
				:widget="item.widget"
				:children="item.children"
				:value="example(item.widget)"
			/>
		</div>
	</el-dialog>
</template>
<script>
import HomeWidget from "@/views/mainIndex/homeWidget.vue";
import { exampleValue, groupHomeItems } from "@/utils/homeLayout";
export default {
	components: { HomeWidget },
	data: () => ({ visible: false, title: "", items: [], device: 'desktop' }),
	computed: {
		sorted() {
			return [...this.items].sort((a, b) => a.placement.row - b.placement.row || a.placement.col - b.placement.col);
		}
	},
	methods: {
		example: exampleValue,
		open(title, items) {
			this.device = 'desktop';
			this.title = title;
			this.items = groupHomeItems(items.map(item => ({ ...item, value: exampleValue(item.widget) })));
			this.visible = true;
		}
	}
};
</script>
<style scoped>
.device-switch { margin-top:16px; }
.preview-grid.mobile { display:flex;flex-direction:column;max-width:390px;margin:auto; }
.preview-grid {
	display: grid;
	grid-template-columns: repeat(12, minmax(0, 1fr));
	gap: 16px;
	padding: 20px 0;
}
@media (max-width: 900px) {
	.preview-grid {
		display: flex;
		flex-direction: column;
	}
}
</style>
